import { reportError } from './monitoring/errorMonitor';
import './monitoring/start';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { initI18nWithoutICU } from '@wix/wix-i18n-config';
import { setBIOptions } from './utils/bi';
import { initWixRecorder } from './utils/initWixRecorder';
import { getApp } from './getApp';
import './global.scss';

const locale = window.__LOCALE__;
const messages = window.__MESSAGES__;
const baseURL = window.__BASEURL__;
const initialState = window.__INITIAL_STATE__;
const consentPolicy = window.__CONSENT_POLICY__;
const device = window.__DEVICE__;
const biOptions = window.__BI__;
const hydrate = window.__HYDRATE__ ?? true;
// Adoric need to have this link in the window
window.templateEditUrl = window.__INITIAL_STATE__.template.editorUrl;

(() => {
  window?.consentPolicyManager?.init({ baseUrl: baseURL, consentPolicy });
  window?.wixTagManager?.init('TEMPLATES', locale);

  initWixRecorder();

  setBIOptions(biOptions);

  const i18n = initI18nWithoutICU({ locale, messages });
  const app = getApp(initialState, i18n, device);

  const container = document.getElementById('root')!;
  if (hydrate) {
    hydrateRoot(container, app, {
      onRecoverableError: (error) => {
        console.error(error);
        reportError(error);
      },
    });
  } else {
    createRoot(container).render(app);
  }
})();
